import { Collapse } from 'antd';
import { DONORS_CSV_HEADERS } from 'modules/donor/constants';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

import { CreateDonorsSchemaType } from '../../schema';

const ErrorMessages: FC = () => {
  const { t } = useTranslation('donor.CsvDonorsUploadingModal.ErrorMessages');

  const formContext = useFormContext<CreateDonorsSchemaType>();
  const errorMessages = formContext.formState.errors.donors || [];
  const csvHeaderErrors = formContext.formState.errors.csvHeaders || [];
  const uploadedHeaders = formContext.getValues('csvHeaders') || [];

  return (
    <Collapse className={styles.collapse}>
      {Object.keys(csvHeaderErrors).length > 0 && (
        <Collapse.Panel header={t('headers') || 'Headers Errors'} key="header">
          <ul className={styles.error}>
            {Object.entries(csvHeaderErrors).map(([keyStr, error]) => {
              if (!error) return null;

              const index = Number(keyStr);

              const message = Array.isArray(error)
                ? error.map((err) => err.message).join(', ')
                : (error as any).message;

              const isExpectedColumn = index < DONORS_CSV_HEADERS.length;

              const actualColumnName =
                uploadedHeaders[index] || `Column ${index + 1}`;

              return (
                <li key={`${message}_${index}`}>
                  {isExpectedColumn
                    ? t('headerMustBe', {
                        index: index + 1,
                        header: DONORS_CSV_HEADERS[index].label,
                      })
                    : t('extraColumn', {
                        columnName: actualColumnName,
                      })}
                </li>
              );
            })}
          </ul>
        </Collapse.Panel>
      )}
      {Array.isArray(errorMessages) &&
        errorMessages.map((donorErrors, i) => {
          if (!donorErrors) return null;

          return (
            <Collapse.Panel header={`Row #${i + 1}`} key={i}>
              <ul className={styles.error}>
                {Object.values(donorErrors).map((error, j) => {
                  const message = Array.isArray(error)
                    ? error.map((err) => err.message).join(', ')
                    : (error as any).message;

                  return <li key={`${message}_${j}`}>{message}</li>;
                })}
              </ul>
            </Collapse.Panel>
          );
        })}
    </Collapse>
  );
};

export default ErrorMessages;
